import { appClientConfig } from '@/app/utils/appClientConfig';
import Link from 'next/link';

import { Typography } from '@material-ui/core';

import styles from './NoResultsMessage.module.scss';

function NoResultsMessage() {
  return (
    <div className={styles.emptyDataNotice}>
      <Typography
        className={styles.heading}
        variant="h6"
        component="p"
        data-testid="job-search-no-results-message"
      >
        There are no jobs matching your criteria
      </Typography>
      <Typography variant="body1" component="p">
        You can try broadening your search criteria or let us do the searching for you! Our team can
        help match you with your ideal job -{' '}
        <Link
          prefetch={false}
          href={`${appClientConfig.practitionerProfileUrl}/register`}
          as={`${appClientConfig.practitionerProfileUrl}/register`}
        >
          <a>simply register now.</a>
        </Link>
      </Typography>
    </div>
  );
}

export default NoResultsMessage;
